<template>
  <router-link class="btn fab" :to="{ name: 'Cart' }">
    <i class="material-icons">shopping_cart</i>
    <div class="badge">
      <span>{{ quantity }}</span>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CartButton',
  computed: {
    ...mapGetters({
      cartQuantity: 'Cart/cartQuantity'
    }),

    quantity() {
      return this.cartQuantity < 100 ? this.cartQuantity : '99+'
    }
  },
}
</script>

<style lang="scss" scoped>
$badgeSize: 29px;
.fab {
  right: 50% !important;
  bottom: 1.2rem !important;
  transform: translateX(50%);
  display: flex !important;
  justify-content: center;
  align-items: center;
  z-index: 999;

  @media only screen and (min-width: 600px) {
    right: 2rem !important;
  }

  .badge {
    position: absolute;
    top: -8px;
    right: 2px;
    width: $badgeSize;
    height: $badgeSize;
    border-radius: 50%;
    color: $text-color;
    background-color: white;
    border: 2px solid $primary-color;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>